import React from 'react';
import PlayerSliderControl from '../sliderControl/SliderControl';
import { getApp } from '../../App';
import style from './TerrainProfile.css';
function ClipPath({ refCallback }) {
    return (React.createElement("svg", { className: style.pathSvg },
        React.createElement("clipPath", { id: 'altitudePath' },
            React.createElement("path", { ref: refCallback }))));
}
class TerrainProfileCanvas extends React.Component {
    constructor(props) {
        super(props);
        this.setClipPathRef = el => {
            this.clipPath = el;
        };
        this.setFgCanvasRef = el => {
            this.fgCanvas = el;
        };
        this.setBgCanvasRef = el => {
            this.bgCanvas = el;
        };
    }
    componentDidMount() {
        const terrainProfile = getApp().terrainProfile;
        terrainProfile.onComponentMounted(this.bgCanvas, this.fgCanvas, this.clipPath);
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        return (React.createElement("div", { className: style.profileHolder },
            React.createElement(ClipPath, { refCallback: this.setClipPathRef }),
            React.createElement("canvas", { className: style.profileCanvas, ref: this.setBgCanvasRef }),
            React.createElement("canvas", { className: style.profileCanvas, ref: this.setFgCanvasRef }),
            React.createElement(PlayerSliderControl, null)));
    }
}
export default TerrainProfileCanvas;
